const originalJsonParse = JSON.parse;
JSON.parse = ((value: string, reviver?: Parameters<typeof JSON.parse>[1]) => {
	if ((value as unknown) === undefined || value === 'undefined') {
		return {};
	}
	return originalJsonParse(value, reviver);
}) as typeof JSON.parse;

import('./Boostrap');
